export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/orbit-02.90e86f2e-fe2c22.svg";